/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsSetExternalUserDefault } from "../../funcs/budgetsSetExternalUserDefault.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SetExternalUserDefaultBudgetRequest$inboundSchema,
};

export const tool$budgetsSetExternalUserDefault: ToolDefinition<typeof args> = {
  name: "budgets-set-external-user-default",
  description: `Set a per-external user default budget

Creates or updates the org's per-external user default budget: a cap applying to EACH external user in the org individually (not in aggregate), unless an explicit external user budget of the same owner and period exists for them. Threshold alerts and blocks fire per external user. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only. Callable by cluster admins, or org admins for their own organization (owner=org).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsSetExternalUserDefault(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
